var _path, _path2, _circle, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-cx",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512z",
    fill: "#1c8a42"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 61.658,
    fill: "#ffc639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.344 228.304c4.218 5.787 10.61 15.49 15.75 12.957 4.012.014 6.083.296 6.627 2.966 9.462 1.61 25.364-2.38 35.26-15.268 0 0 .83.11.542-4.79.055-2.132 2.918-1.706 2.986-1.01.4 1.06.33 1.85.867 1.878 1.218-.406 2.883-3.138 4.28-4.872.38-.764.172-1.57.262-2.532.736-1.81 2.573-1.418 2.958-.468.35.612.358 1.08.702 1.693 1.865 1.245 5.23.082 5.49.082.33-1.522 1.31-1.377 1.31-1.377 1.244-.275.755-.165 1.574.26-.72 8.197 1.61 8.56 1.42 12.765.08 4.693-1.42 6.028-1.42 7.817.476 2.188 7.398 2.264 4.962 4.114-2.14 1.142.007 3.282-3.213 4.114-9.373 4.755-11.17 8.835-11.17 8.835s-2.352 4.444-2.613 4.444c-1.57 2.966-3.558 1.35-4.666 2.794-.55 1.817-1.168 5.842-.067 7.934.55 2.876-.07 4.445-.757 7.32-.62 6-3 6.91-3.276 9.015-1.1 2.25.234 12.82-.812 12.82-6.976.137-12.323-1.336-15.082-1.886 2.69-11.594 1.644-21.777 1.644-22.823-.688-8.292-12.42-6.275-14.216-7.376-1.486-.316-2.422-1.527-2.945-2.05-1.66-.18-2.278-.557-3.937-.73-.825.414-.33.84-2.174 1.412-4.68.564-6.744-4.08-6.744-4.08.227-1.563-10.52.316-16.363-1.04-2.395 1.335-3.44 5.285-5.402 5.753-.054 1.224-3.226-1.005-3.866-2.21-.13-3.502 3.055-5.05 3.055-5.05 2.532-1.782 4.032-2.07 5.25-3.303.612-3.048.302-5.305 1.603-7.596 1.1-1.748 2.725-.93 3.826-1.714 1.182-.784 1.684-5.917.59-7.32 0 0-4.734-4.274-4.995-4.535-1.54-4.417 1.803-7.266 2.76-6.943z",
    fill: "#1c8a42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M452.254 63.723c-2.793-11.055-27.798-34.865-46.59-50.016-4.486-3.056-7.41-1.236-6.825 3.122 2.338 3.9 4.093 8.19 6.432 12.093.654 2.6 1.886 4.422 2.54 7.022 0 0 .192 4.487.584 4.877 5.85 6.44 6.633 11.9 6.633 11.9 3.378 6.503 6.37 11.25 12.29 16.582 6.632 4.163 1.753 17.1 1.946 23.994 0 4.355-3.117 3.84-5.85 3.316-21.522-19.768-42.852-19.83-61.644-25.555-7.35-.78-7.48 2.73-5.07 4.678 13.135 14.05 25.485 23.608 41.744 31.603l8.196 5.08c3.117 2.6 6.24 5.2 9.358 7.802 7.218 4.68 7.81 8.972 7.81 9.358.192 8.78-4.494 15.606-5.856 18.337-2.463 9.31-7.41 10.927-7.41 10.927-40.192 27.118-61.26 34.136-126.417 25.748-.977-.516-7.217.523 0 3.124 16.583 5.525 57.318 14.388 96.727-4.273 9.46-6.633 15.792-4.46 22.645-8.43 11.256-6.942 27.33-15.584 30.254-16.554 8.78-4.687 33.36-9.95 39.02-14.637 6.497-.523 13.24-1.376 13.694-6.963 2.133-1.383 5.257-.372 7.576-4.927 5.154-.894 4.287-2.738 4.287-2.738-1.3-3.64-6.116-5.14-9.557-7.803-5.078-1.693-8.587-2.216-12.296-.392-1.17.523-2.34 1.04-3.51 1.562 0 0-5.462-.785-5.462-1.17-12.138-.668-10.955-40.893-15.248-57.67z",
    fill: "#ffc639"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M542.467 217.777a3.005 1.878 15.947 1 1-5.73-1.8 3.005 1.878 15.947 0 1 5.73 1.8z",
    fill: "#1c8a42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.826 182.362) scale(.68267)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M188.16 190.94l-12.75-11.936-12.905 11.77 1.383-17.405-17.25-2.754 14.476-9.774-8.606-15.197 16.668 5.22 6.518-16.205 6.31 16.287 16.734-5.007-8.8 15.086 14.348 9.96-17.283 2.53 1.158 17.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.39 335.53l-13.752-9.167-13.39 9.664 4.71-15.568-13.58-9.416 16.666-.446 4.988-15.496 5.595 15.3 16.667-.156-13.21 9.902 5.307 15.382z"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 2.522,
    y: 269.061
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: -112.066,
    y: 123.223
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 108.427,
    y: 85.027
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/cx.15a4d0445be88cc0205ebd80357c94c0.svg";
export { ForwardRef as ReactComponent };